








































































































import { ShortcutContext } from '@/app/Shortcuts';
import { Preferences, PreferenceCategory } from '@/app/Preference';
import { ExpressionVisuals } from './ExpressionVisuals';
import ExpressionBase from './ExpressionBase';


const PREF_SHORTCUT_COPY = Preferences.define({
  key: 'expression_copy',
  label: 'Copy expression shortcut',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.SHORTCUT],
  defaultValue: '67__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_PASTE = Preferences.define({
  key: 'expression_paste',
  label: 'Paste expression shortcut',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.SHORTCUT],
  defaultValue: '86__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_CUT = Preferences.define({
  key: 'expression_cut',
  label: 'Cut expression shortcut',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.SHORTCUT],
  defaultValue: '88__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_REMOVE = Preferences.define({
  key: 'expression_remove',
  label: 'Remove expression shortcut',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.SHORTCUT],
  defaultValue: '8__c',
  component: 'ex-shortcut-input',
});


export default ExpressionBase().extend({
  name: 'Expression',
  computed: {
    starters(): ExpressionVisuals[] {
      return this.registry.getExpressionsStart(this.requiredType);
    },
    statusColor(): string {
      return this.invalid ? this.displayOptions.error : this.displayOptions.color;
    },
    compact(): boolean {
      return this.displayOptions.compact;
    },
    shortcuts(): ShortcutContext {
      return {
        downs: {
          [Preferences.get(PREF_SHORTCUT_COPY)]: this.copyExpression,
          [Preferences.get(PREF_SHORTCUT_PASTE)]: this.pasteExpression,
          [Preferences.get(PREF_SHORTCUT_CUT)]: this.cutExpression,
          [Preferences.get(PREF_SHORTCUT_REMOVE)]: this.requestRemove,
        },
      };
    },
  },
  methods: {
    startWith(visuals: ExpressionVisuals) {
      this.input(visuals.create(this.requiredType, this.context, this.registry));
    },
  },
});
